import React, { useState } from 'react';
// import { useTimer } from '../contexts/TimerContext';
import './GuestCheckoutPopup.css';

const GuestCheckoutPopup = ({ isOpen, onClose, onGuestDetailsSubmit, onSwitchToLogin }) => {
  // const { formattedTime, isExpired } = useTimer();
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    name: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const showError = (message) => {
    setErrorMessage(message);
    setShowErrorPopup(true);
  };

  // // Handle timer expiration
  // React.useEffect(() => {
  //   if (isExpired && isOpen) {
  //     showError('Session expired! Please start over.');
  //     onClose();
  //   }
  // }, [isExpired, isOpen, onClose]);

  // Reset form when popup opens
  React.useEffect(() => {
    if (isOpen) {
      setFormData({ email: '', phone: '', name: '' });
      setErrors({});
    }
  }, [isOpen]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Remove spaces and special characters for validation
    const cleanPhone = phone.replace(/\s+/g, '').replace(/-/g, '');
    // Check if it's a valid phone number (10 digits minimum, can have country code)
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    return cleanPhone.length >= 10 && phoneRegex.test(cleanPhone);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    const newErrors = {};
    
    if (!formData.email || !formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    if (!formData.phone || !formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
    }
    
    // Name is optional, but if provided, should not be empty
    if (formData.name && formData.name.trim().length === 0) {
      newErrors.name = 'Name cannot be empty';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Clean phone number (remove spaces, dashes)
      const cleanPhone = formData.phone.replace(/\s+/g, '').replace(/-/g, '');
      
      // Prepare guest details
      const guestDetails = {
        email: formData.email.trim().toLowerCase(),
        phone: cleanPhone,
        name: formData.name.trim() || formData.email.trim().split('@')[0] || 'Guest', // Use email prefix if name not provided
      };
      
      // Call parent callback with guest details
      onGuestDetailsSubmit(guestDetails);
    } catch (error) {
      console.error('Error submitting guest details:', error);
      showError('Failed to proceed. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="guest-checkout-overlay">
      <div className="guest-checkout-popup">
        {/* Close button - top right */}
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>

        {/* Timer - top left */}
        {/* <div className="timer-display">
          {isExpired ? 'Session Expired' : `${formattedTime} Mins Remaining`}
        </div> */}

        {/* Simple Hero Section */}
        <div className="simple-hero">
          <div className="floating-elements">
            <div className="floating-icon">🎬</div>
            <div className="floating-icon">🍿</div>
            <div className="floating-icon">🎫</div>
          </div>
        </div>

        {/* Main Content */}
        <div className="popup-content">
          <h2 className="popup-title">Guest Checkout</h2>
          <p className="popup-subtitle">Enter your details to continue</p>
          <form onSubmit={handleSubmit} className="guest-form">

{/* Email - Full Width */}
<div className="form-group full-width">
  <label htmlFor="email" className="form-label">
    Email <span className="required">*</span>
  </label>

  <input
    type="email"
    id="email"
    name="email"
    placeholder="your.email@example.com"
    value={formData.email}
    onChange={handleInputChange}
    className={`form-input ${errors.email ? 'error' : ''}`}
    required
  />

  {errors.email && (
    <span className="error-message">{errors.email}</span>
  )}
</div>

{/* Phone - Left Column */}
<div className="form-group">
  <label htmlFor="phone" className="form-label">
    Phone Number <span className="required">*</span>
  </label>

  <input
    type="tel"
    id="phone"
    name="phone"
    placeholder="+91 9876543210"
    value={formData.phone}
    onChange={handleInputChange}
    className={`form-input ${errors.phone ? 'error' : ''}`}
    required
  />

  {errors.phone && (
    <span className="error-message">{errors.phone}</span>
  )}
</div>

{/* Name - Right Column */}
<div className="form-group">
  <label htmlFor="name" className="form-label">
    Name <span className="optional">(Optional)</span>
  </label>

  <input
    type="text"
    id="name"
    name="name"
    placeholder="Your name"
    value={formData.name}
    onChange={handleInputChange}
    className={`form-input ${errors.name ? 'error' : ''}`}
  />

  {errors.name && (
    <span className="error-message">{errors.name}</span>
  )}
</div>

{/* Continue Button - Full Width */}
<button
  type="submit"
  className="proceed-btn"
  disabled={isSubmitting}
>
  {isSubmitting ? 'Processing...' : 'Continue to Payment'}
</button>

</form>

          {onSwitchToLogin && (
            <>
              {/* <div className="divider">
                <span className="divider-text">OR</span>
              </div> */}
              <button 
                className="switch-to-login-btn" 
                onClick={onSwitchToLogin}
                type="button"
              >
                Sign In / Sign Up
              </button>
            </>
          )}
        </div>
      </div>

      {showErrorPopup && (
      <div className="error-popup-overlay" onClick={() => setShowErrorPopup(false)}>
        <div className="error-popup-content" onClick={(e) => e.stopPropagation()}>
          <div className="error-popup-icon">
            <i className="fas fa-exclamation-circle"></i>
          </div>
          <div className="error-popup-message">
            {errorMessage}
          </div>
          <button
            className="error-popup-button"
            onClick={() => setShowErrorPopup(false)}
          >
            OK
          </button>
        </div>
      </div>
    )}
    </div>
  );
};

export default GuestCheckoutPopup;

